module.exports = {"apiUrl":"https://eapi2.ahlamkom.net"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 155
// module chunks = 0